import React from 'react';
import { motion } from 'framer-motion';
export function NobodyToldYou() {
  return <section className="py-20 md:py-28 bg-[#111111] text-[#FAF7F2]" data-id="element-159">
      <div className="max-w-3xl mx-auto px-4" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-161">
          <p className="text-[#C5A55A] text-sm uppercase tracking-widest mb-4" data-id="element-162">
            🔥 Lo que nadie te dijo
          </p>
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A]" data-id="element-163">
            El amor no alcanza.
          </h2>
        </motion.div>

        <div className="space-y-10" data-id="element-164">
          <motion.div initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="space-y-1" data-id="element-165">
            <p className="text-2xl md:text-3xl font-serif text-[#FAF7F2]/80 font-light" data-id="element-166">
              El amor no mantiene el deseo.
            </p>
            <p className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A]" data-id="element-167">
              La intención sí.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="space-y-1" data-id="element-168">
            <p className="text-2xl md:text-3xl font-serif text-[#FAF7F2]/80 font-light" data-id="element-169">
              La intimidad no se sostiene sola.
            </p>
            <p className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A]" data-id="element-170">
              Se construye.
            </p>
          </motion.div>

          <div className="w-full h-px bg-[#C5A55A]/20 my-4" data-id="element-171"></div>

          <motion.div initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-172">
            <p className="text-xl md:text-2xl text-[#FAF7F2]/70 font-light leading-relaxed" data-id="element-173">
              Y si no sabes cómo hacerlo… improvisas.
            </p>
            <p className="text-xl md:text-2xl text-[#FAF7F2] font-medium mt-1" data-id="element-174">
              Y cuando improvisas… te resignas.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}